module.exports = __webpack_public_path__ + "static/img/4-info.d31bdcf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/4-info.png
// module id = MCOn
// module chunks = 0